/**
 * tp-rte-table-scroll
 * Macht ueberbreite RTE-/Artikel-Tabellen per Tastatur scrollbar (WCAG 2.1.1 /
 * axe scrollable-region-focusable). Jede .rte table wird einmal in einen
 * fokussierbaren Wrapper (role=region) gepackt; tabindex/role werden nur gesetzt,
 * wenn die Tabelle tatsaechlich horizontal ueberlaeuft (kein unnoetiger Tabstopp).
 * Reines Progressive Enhancement, ES5.
 */
(function () {
  'use strict';

  var SELECTOR = '.rte table';
  var WRAP_CLASS = 'tp-table-scroll';
  var LABEL = 'Tabelle, horizontal scrollbar';

  function ensureWrapped(table) {
    var parent = table.parentNode;
    if (parent && parent.classList && parent.classList.contains(WRAP_CLASS)) {
      return parent;
    }
    var wrapper = document.createElement('div');
    wrapper.className = WRAP_CLASS;
    table.parentNode.insertBefore(wrapper, table);
    wrapper.appendChild(table);
    return wrapper;
  }

  function refresh() {
    var tables = document.querySelectorAll(SELECTOR);
    for (var i = 0; i < tables.length; i++) {
      var wrapper = ensureWrapped(tables[i]);
      if (wrapper.scrollWidth > wrapper.clientWidth + 1) {
        wrapper.setAttribute('tabindex', '0');
        wrapper.setAttribute('role', 'region');
        wrapper.setAttribute('aria-label', LABEL);
      } else {
        wrapper.removeAttribute('tabindex');
        wrapper.removeAttribute('role');
        wrapper.removeAttribute('aria-label');
      }
    }
  }

  var timer;
  function onResize() {
    clearTimeout(timer);
    timer = setTimeout(refresh, 200);
  }

  function init() {
    refresh();
    window.addEventListener('resize', onResize);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
